import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { formatTimeStr, formatDateStr } from 'utils';
import Pagination from '../../../react-common/Pagination';

function VirtualTourList({ ErrorService, listingId }) {
  const limit = 20;
  const [state, setState] = useState({
    virtualTours: [],
    isLoading: false,
    page: 1,
    order: 'DESC',
    virtualToursCount: 0,
  });

  const loadTours = async () => {
    if (!state.isLoading) {
      setState(preState => ({
        ...preState,
        isLoading: true,
      }));
      try {
        const { data } = await axios.get(
          `/listing/${listingId}/virtual_tour/paginate`,
          {
            params: {
              page: state.page,
              limit,
            },
          },
        );
        setState(preState => ({
          ...preState,
          virtualTours: data.virtualTours,
          virtualToursCount: data.virtualToursCount,
        }));
      } catch (err) {
        ErrorService.toastyHTTPErr(err);
      }
      setState(preState => ({
        ...preState,
        isLoading: false,
      }));
    }
  };

  const onPageChange = page => {
    setState(preState => ({
      ...preState,
      page,
    }));
  };

  useEffect(() => {
    loadTours();
  }, [state.page]);

  return (
    <div className="col-md-12">
      {state.virtualTours.length > 0 && (
        <div className="listing-num-appts">
          {state.virtualToursCount > 20 && (
            <Pagination
              totalItems={state.virtualToursCount}
              itemsPerPage={limit}
              maxSize={5}
              currentPage={state.page}
              onChange={onPageChange}
              disabled={state.isLoading}
            />
          )}
          <span
            style={{
              display: 'inline-block',
              verticalAlign: 'top',
              lineHeight: '32px',
              margin: '0 10px',
            }}
          >
            {' '}
            Total: {state.virtualToursCount}{' '}
            {state.virtualToursCount > 1 ? 'Tours' : 'Tour'}
          </span>
        </div>
      )}
      {state.virtualTours.length === 0 && !state.isLoading && (
        <h5>No tours found for listing.</h5>
      )}
      <div
        className="table-responsive"
        style={{ height: '80vh', overflowY: 'auto' }}
      >
        {state.virtualTours.length > 0 && (
          <table className="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>
                  <a>Date</a>
                  <i className="fa fa-sort"></i>
                </th>
                <th className="hidden-xs">
                  <a>Showing Agent</a>
                  <i className="fa fa-sort"></i>
                </th>
                <th className="hidden-xs">Contact</th>
                <th className="hidden-xs">
                  Feedback
                  <a href={`#/listing/${listingId}/feedbacks`}>
                    <i className="fa fa-expand"></i>
                  </a>
                </th>
                <th className="hidden-xs">
                  <a>Status</a>
                  <i className="fa fa-sort"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              {state.virtualTours.map((virtualTour, i) => (
                <tr key={i}>
                  <td className="hidden-xs">
                    <span>
                      {formatDateStr(
                        virtualTour.startTime,
                        virtualTour.timezone,
                      )}
                    </span>
                    <br />
                    <span>
                      {formatTimeStr(
                        virtualTour.startTime,
                        virtualTour.timezone,
                      )}
                    </span>
                  </td>
                  <td className="hidden-xs">
                    {virtualTour.coop?.name}
                    <div className="table-cell-light">
                      <strong>{virtualTour.coop?.org?.name}</strong>
                    </div>
                  </td>
                  <td className="hidden-xs">
                    {virtualTour.coop?.phone && (
                      <span>
                        M:
                        <a href={`tel:${virtualTour.coop?.phone}`}>
                          {virtualTour.coop?.phone}
                        </a>
                        <br />
                      </span>
                    )}
                    O:
                    <a href={`tel:${virtualTour.coop?.org?.phone}`}>
                      {virtualTour.coop?.org?.phone}
                    </a>
                    <br />
                    <a href={`mailto:${virtualTour.coop?.email}`}>
                      {virtualTour.coop?.email}
                    </a>
                  </td>
                  <td className="hidden-xs">
                    {' '}
                    <span>N/A</span>
                  </td>
                  <td className="hidden-xs text-success">
                    {/* todo fetching status from backend */}
                    Virtual Showing
                  </td>
                  <td className="visible-xs">
                    <div
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: 'calc(100vw - 160px - 78px)',
                        minWidth: '128px',
                      }}
                    >
                      <span className="h5">
                        <span style={{ fontWeight: 600 }}>
                          {formatDateStr(
                            virtualTour.startTime,
                            virtualTour.timezone,
                          )}
                        </span>
                        <br />
                        <span style={{ fontWeight: 300 }}>
                          {formatTimeStr(
                            virtualTour.startTime,
                            virtualTour.timezone,
                          )}{' '}
                          <br />
                        </span>
                      </span>
                      {virtualTour.coop?.name} <br />
                      <span>{virtualTour.coop?.org?.name}</span>
                      <span>
                        <br />
                        {virtualTour.coop?.phone && (
                          <span>
                            m:
                            <a href={`tel:${virtualTour.coop?.phone}`}>
                              {virtualTour.coop?.phone}
                            </a>
                            <br />
                          </span>
                        )}
                        o:
                        <a href={`tel:${virtualTour.coop?.org?.phone}`}>
                          {virtualTour.coop?.org?.phone}
                        </a>
                        <br />
                        email:
                        <a href={`mailto:${virtualTour.coop?.email}`}>
                          {virtualTour.coop?.email}
                        </a>
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <div
          style={{
            display: 'inline-block',
            textAlign: 'center',
            width: '100%',
          }}
        >
          {state.isLoading ? (
            <i className="fa fa-spinner fa-spin"></i>
          ) : (
            state.virtualTours.length < limit && <p>No More Tours</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default VirtualTourList;
